
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 mb-8">
          <div>
            <img 
              src="https://thejoyschoolvalinhos.com.br/wp-content/uploads/2025/08/logo-novo-scaled.png"
              alt="The Joy School Paulínia"
              className="h-16 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-gray-300 leading-relaxed">
              Escola particular de Paulínia com ensino bilíngue e qualidade superior.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Entre em Contato</h3>
            <ul className="space-y-3">
              <li>
                <a href="https://wa.me/5519989250972" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-phone-fill"></i>
                  <span>(19) 98925-0972</span>
                </a>
              </li>
              <li>
                <a href="mailto:sacpaulinia@thejoyschool.com.br" className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors cursor-pointer">
                  <i className="ri-mail-fill"></i>
                  <span>sacpaulinia@thejoyschool.com.br</span>
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-300">
                <i className="ri-map-pin-fill mt-1"></i>
                <span>Paulínia - SP</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Siga-nos</h3>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/thejoyschoolpaulinia/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-pink-500 to-purple-600 rounded-full hover:scale-110 transition-all cursor-pointer shadow-lg"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm text-center md:text-left">
            © 2025 The Joy School Paulínia. Todos os direitos reservados.
          </p>
          <a 
            href="https://guepardosites.link" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Criado por guepardosites.link
          </a>
        </div>
      </div>
    </footer>
  );
}
